import { defineComponent as _defineComponent } from 'vue'
import FileUploader from "@/components/epubguide/FileUploader.vue";
import {
  GetCSVUploadLinkRequest,
  GetCSVUploadLinkResponse,
  GetEpubsResponse, UpdateEpubRequest, ValidateCsvRequest, ValidateCsvResponse
} from "@ilteducation/epub-guide-generator-types";
import { computed, ref } from "vue";
import axios from "axios";
import config from "@/config/ConfigProvider";
import eventBus from "@/foundations/services/eventBus";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditEpubGuideform',
  props: {
    selectedEpubs: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedEpubs: GetEpubsResponse[];
}






const isUpdating = ref<boolean>(false);
const hasChanged = ref<boolean>(false);
const languages = computed(() => props.selectedEpubs.map((epub) => epub.body.language));

const form = ref({
  updateToc: false,
  uploadedCSV: undefined as File | undefined,
  pagesToUpdate: '',
  pushToCR: false,
});

const fileChanged = (file: File | undefined) => {
  form.value.uploadedCSV = file;
  form.value.updateToc = true;
};

const handleFormChange = () => {
  hasChanged.value = true;
};

const hasSameIsbn = computed(() => {
  const isbns = props.selectedEpubs.map((epub) => epub.isbn);
  return isbns.every((isbn) => isbn === isbns[0]);
});

const handleClose = () => {
  emit('close');
};

const uploadCsv = async () => {
  try {
    const data: GetCSVUploadLinkRequest = {
      languages: languages.value,
      fileName: form.value.uploadedCSV!.name.replace('.csv', ''),
      pushToCR: form.value.pushToCR,
    };
    const res = await axios.post(`${config.value('epubGuideGeneratorUrl')}/getCsvUploadLink`, data);
    if(res.data.type !== 'SuccessResponseV1') {
      throw new Error('Failed to get upload link');
    }
    const { uploadLink }: GetCSVUploadLinkResponse = res.data.payload;

    await fetch(uploadLink, {
      method: 'PUT',
      body: form.value.uploadedCSV,
      headers: {
        'Content-Type': 'text/csv',
      },
    });
  } catch (error) {
    console.error(error);
    eventBus.$emit('snackbar.open', 'Error uploading file');
  }
};

const validateCSV = async () => {
  const data: ValidateCsvRequest = {
    fileName: form.value.uploadedCSV!.name.replace('.csv', ''),
  };
  return axios.post(`${config.value('epubGuideGeneratorUrl')}/validateCSV`, data);
}

const startUpdate = async (id: string) => {
  const data: UpdateEpubRequest = {
    id,
    updateToc: form.value.updateToc,
    csvFileName: form.value.uploadedCSV ? form.value.uploadedCSV.name.replace('.csv', '') || null : null,
    pagesToUpdate: form.value.pagesToUpdate,
    pushToCR: form.value.pushToCR,
  };
  return axios.post(`${config.value('epubGuideGeneratorUrl')}/updateEpub`, data);
}


const editEpub = async () => {
  isUpdating.value = true;
  try {
    if (form.value.uploadedCSV) {
      await uploadCsv();
      await validateCSV();
    }
    for (const epub of props.selectedEpubs) {
      try {
        await startUpdate(epub.id);
      } catch (error) {
        console.error(error);
        eventBus.$emit('snackbar.open', 'Error during update.');
      } finally {
        handleClose();
        eventBus.$emit('snackbar.open', 'Update epub process started. Allow a few minutes for the EPUB to be generated before checking the table below.');
      }
    }
  } catch (error) {
    console.error(error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data.error as ValidateCsvResponse;
        eventBus.$emit('snackbar.open', `CSV is not valid. Errors: ${data.errors!.join(', ')}`);
      }
    } else {
      eventBus.$emit('snackbar.open', 'Error starting generation');
    }
  } finally {
    isUpdating.value = false;
  }
};

return { __sfc: true,props, emit, isUpdating, hasChanged, languages, form, fileChanged, handleFormChange, hasSameIsbn, handleClose, uploadCsv, validateCSV, startUpdate, editEpub, FileUploader }
}

})